import { render, staticRenderFns } from "./DrawingInput.vue?vue&type=template&id=0b4eb353&scoped=true"
import script from "./DrawingInput.vue?vue&type=script&lang=js"
export * from "./DrawingInput.vue?vue&type=script&lang=js"
import style0 from "./DrawingInput.vue?vue&type=style&index=0&id=0b4eb353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4eb353",
  null
  
)

export default component.exports